<template>
  <div>
    <img src="@/assets/img/o_6.png" class="bjImg" alt="">
    <div class="boxCont">
      <div class="boxCont_padd outer_one">
        <div class="outer_one_1 animate__animated animation_title">店星人打单</div>
        <div class="outer_one_2 animate__animated animation_title">多平台一键打单，省时省力</div>
      </div>
      <div class="boxCont_padd outer_two animate__animated animation_title">
        <div class="outer_two_cont settingStyle elementHover"
          :style="'backgroundImage:url(' + require('@/assets/img/o_7.png') + ')'">
          <div class="outer_two_cont_left">
            <img src="@/assets/img/o_13.png" class="outer_two_cont_lef_1" alt="" />
            <div class="outer_two_cont_lef_2">多平台一键打单，实时同步，智能分单查询调度</div>
          </div>
          <div class="outer_two_cont_right" @click="downloadApp">前往官网</div>
        </div>
      </div>
      <div class="boxCont_padd outer_tip outer_tip_1 animate__animated">来了解一下我们</div>
      <div class="boxCont_padd outer_three animate__animated">
        <div class="outer_three_cont">
          <div class="outer_three_left">
            <div class="outer_three_left_1">简单高效</div>
            <div class="outer_three_left_2">数据统计 一键打单</div>
            <div class="outer_three_left_3">店星人是一款专为电商人士、销售团队以及企业提供的高效资源与订单处理工具。</div>
            <div class="outer_three_left_3">它旨在简化销售流程，提升工作效率，使用者能够便捷轻松地管理订单、流转单等各类单据。</div>
          </div>
          <img src="@/assets/img/o_8.png" class="outer_three_right" alt="">
        </div>
      </div>
      <div class="boxCont_padd outer_four">
        <div class="outer_four_item animate__animated elementHover" v-for="(item, index) in featureList" :key="index"
          :style="{ background: item.bg, transitionDelay: 0.1 * (index + 1) + 's' }">
          <div class="outer_four_item_1">{{ item.title }}</div>
          <div class="outer_four_item_2">{{ item.desc }}</div>
          <img :src="item.img" class="outer_four_item_3" alt="">
        </div>
      </div>
      <div class="outer_five">
        <div class="boxCont_padd outer_tip outer_tip_2 animate__animated">多平台、多店铺统一管理</div>
        <div class="boxCont_padd outer_five_cont animate__animated">
          <div class="outer_five_row">
            <div class="outer_five_item elementHover" v-for="(item, index) in platformList" :key="item.id || index">
              <img :src="item.image" class="outer_five_item_img" :alt="item.title">
            </div>
          </div>
        </div>
      </div>
      <div class="boxCont_padd outer_six">
        <div class="outer_six_left animate__animated">
          <div class="outer_six_left_cont">
            <div class="outer_six_left_1">知名品牌</div>
            <div class="outer_six_left_2">共同选择我们</div>
          </div>
          <div class="outer_six_left_3">
            <div class="outer_six_left_3_row">
              <div class="outer_six_left_3_track outer_six_left_3_track_l">
                <div class="outer_six_left_3_item" v-for="(item, index) in brandListTop" :key="'r1-' + index">
                  <img :src="item.image" class="outer_six_left_3_item_img" :alt="item.title">
                </div>
              </div>
            </div>
            <div class="outer_six_left_3_row">
              <div class="outer_six_left_3_track outer_six_left_3_track_r">
                <div class="outer_six_left_3_item" v-for="(item, index) in brandListBottom" :key="'r2-' + index">
                  <img :src="item.image" class="outer_six_left_3_item_img" :alt="item.title">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="outer_six_right animate__animated">
          <div class="outer_six_right_text">
            <div class="outer_six_right_1">功能清晰</div>
            <div class="outer_six_right_2">一键分销发货</div>
          </div>
          <img src="@/assets/img/o_12.png" class="outer_six_right_img" alt="">
        </div>
      </div>
      <commonFoot class="commonFoot animate__animated" type="3"></commonFoot>
    </div>
  </div>
</template>

<script>
  // Created by www.xingnuocn.com
  // @title: 店星人打单详情
  // @author: 刘嘉鑫
  import commonFoot from "@/components/commonFoot.vue";
  export default {
    components: {
      commonFoot,
    },
    data() {
      return {
        featureList: [{
          title: "店铺设置",
          desc: "绑定平台店铺，创建管理员账号，新建部分仓库。",
          img: require("@/assets/img/o_9.png"),
          bg: "linear-gradient(180deg, #EFF7FF 0%, #E6ECF4 100%)",
        }, {
          title: "快递设置",
          desc: "根据基础信息，设置自定义快递功能。",
          img: require("@/assets/img/o_10.png"),
          bg: "linear-gradient(180deg, #FFEDB8 0%, #FFF8E2 100%)",
        }, {
          title: "商品匹配",
          desc: "简化匹配线上商品，进行本地商品匹配。",
          img: require("@/assets/img/0_11.png"),
          bg: "linear-gradient(180deg, #EFF7FF 0%, #E6ECF4 100%)",
        }, {
          title: "爆款打单",
          desc: "质检合并订单整合提示，便捷一键操作打单/发货。",
          img: require("@/assets/img/o_5.png"),
          bg: "linear-gradient(180deg, #CFBDFF 0%, #EBE4FF 100%)",
        }],
        platformList: [],
        brandListTop: [],
        brandListBottom: [],
      }
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScrollbox, true);
    },
    mounted() {
      this.getPlatformList();
      this.getCoBrandList();
      window.addEventListener("scroll", this.handleScrollbox, true);
      this.$nextTick(() => {
        this.handleScrollbox();
      });
    },
    methods: {
      // 电商平台列表
      getPlatformList() {
        this.$request({
          url: "/Index/shopPlatformList",
        }).then((res) => {
          this.platformList = res.list || [];
        });
      },

      // 合作品牌列表（拆成两行对向滚动）
      getCoBrandList() {
        this.$request({
          url: "/Index/coBrandList",
        }).then((res) => {
          const list = res.list || [];
          const mid = Math.ceil(list.length / 2);
          const top = list.slice(0, mid);
          const bottom = list.slice(mid);
          // 复制一份保证无限滚动无缝衔接
          this.brandListTop = top.length ? top.concat(top) : [];
          this.brandListBottom = bottom.length ? bottom.concat(bottom) : [];
        });
      },

      // 前往官网
      downloadApp() {
        window.open("https://dianxingren.com/dxrh5/", "_blank");
      },

      /**
       * 动画效果
       * 刘嘉鑫
       * 2025-1-15
       */
      handleScrollbox() {
        this.currentScroll = window.pageYOffset;
        if (this.currentScroll >= this.$(".outer_two").offset().top - 950) {
          this.$(".outer_tip_1").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_two").offset().top - 700) {
          this.$(".outer_three").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_three").offset().top - 200) {
          this.$(".outer_four_item").addClass(" showDiv");
        }
        if (this.currentScroll >= this.$(".outer_four").offset().top - 100) {
          this.$(".outer_tip_2").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_four").offset().top + 100) {
          this.$(".outer_five_cont").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_five").offset().top + 100) {
          this.$(".outer_six_left").addClass(" animation_title");
          this.$(".outer_six_right").addClass(" animation_title");
        }
        if (this.currentScroll >= this.$(".outer_six").offset().top - 400) {
          this.$(".commonFoot").addClass(" animation_title");
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .bjImg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1036px;
  }

  .boxCont_padd {
    padding-left: 160px;
    padding-right: 160px;
  }

  .boxCont {
    position: relative;
    z-index: 99;
    padding: 190px 0 0;
  }

  .outer_one {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 80px;

    .outer_one_1 {
      font-weight: 700;
      font-size: 54px;
      color: #2A303A;
      letter-spacing: 6px;
    }

    .outer_one_2 {
      font-weight: 700;
      font-size: 22px;
      color: #333A47;
      letter-spacing: 2px;
    }
  }

  .outer_two {
    position: relative;
    margin-bottom: 100px;

    .outer_two_cont {
      position: relative;
      padding: 120px 100px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 40px;
      overflow: hidden;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      .outer_two_cont_left {
        .outer_two_cont_lef_1 {
          width: 368px;
          height: 105px;
          margin-bottom: 80px;
        }

        .outer_two_cont_lef_2 {
          font-weight: 400;
          font-size: 20px;
          color: #FFFFFF;
          letter-spacing: 2px;
        }
      }

      .outer_two_cont_right {
        background: #FFFFFF;
        border-radius: 66px;
        padding: 15px 34px;
        font-weight: bold;
        font-size: 17px;
        color: #0057FE;
        cursor: pointer;
        flex-shrink: 0;
      }
    }
  }

  .outer_tip {
    font-weight: 400;
    font-size: 42px;
    color: #2A303A;
    margin-bottom: 80px;
    opacity: 0;
    letter-spacing: 3px;
  }

  .outer_three {
    margin-bottom: 40px;

    .outer_three_cont {
      background: linear-gradient(180deg, rgba(239, 247, 255, .8) 0%, rgba(230, 236, 244, .8) 100%);
      border-radius: 40px;
      padding: 94px 100px 50px 200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .outer_three_left {
      width: 28%;

      .outer_three_left_1 {
        font-weight: 700;
        font-size: 24px;
        color: #0057FE;
        margin-bottom: 20px;
        letter-spacing: 2px;
      }

      .outer_three_left_2 {
        font-weight: 700;
        font-size: 28px;
        color: #333A47;
        margin-bottom: 40px;
        letter-spacing: 3px;
      }

      .outer_three_left_3 {
        font-weight: 400;
        font-size: 17px;
        color: #5D6574;
        line-height: 32px;
        margin-bottom: 20px;
        letter-spacing: 2px;
      }
    }

    .outer_three_right {
      width: 685px;
      /* max-width: 48%; */
      height: auto;
      object-fit: contain;
    }
  }

  .outer_four {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 40px;
    margin-bottom: 62px;

    .outer_four_item {
      border-radius: 40px;
      padding: 75px 74px 70px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      transition: all 0.7s ease-out 0s;
      transform: translate(0px, 70px);
      opacity: 0;

      .outer_four_item_1 {
        font-weight: 700;
        font-size: 26px;
        color: #333A47;
        margin-bottom: 18px;
        letter-spacing: 2px;
      }

      .outer_four_item_2 {
        font-weight: 400;
        font-size: 16px;
        color: #5D6574;
        line-height: 26px;
        letter-spacing: 1px;
        margin-bottom: 80px;
      }

      .outer_four_item_3 {
        width: 126px;
        height: 126px;
        object-fit: contain;
        margin-top: auto;
      }
    }
  }

  .outer_five {
    background: linear-gradient(180deg, #EFF7FF 0%, #E6ECF4 100%);
    padding: 100px 0;
    margin-bottom: 100px;

    .outer_five_cont {
      opacity: 0;
    }

    .outer_five_row {
      display: grid;
      grid-template-columns: repeat(8, 1fr);
      gap: 50px 34px;
    }

    .outer_five_item {
      background: #FFFFFF;
      border-radius: 16px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 16px rgba(42, 48, 58, 0.06);
      padding: 16px 20px;
      box-sizing: border-box;

      .outer_five_item_img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }
  }

  .outer_six {
    display: flex;
    gap: 40px;
    margin-bottom: 60px;

    .outer_six_left {
      flex: 1.6 1 0;
      min-width: 0;
      width: 0;
      border-radius: 40px;
      padding: 56px 0 56px 80px;
      background: #18232F;
      opacity: 0;
      display: flex;
      align-items: center;
      overflow: hidden;

      .outer_six_left_cont {
        flex-shrink: 0;
        width: 220px;
        margin-right: 20px;
      }

      .outer_six_left_1 {
        font-weight: 700;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 2px;
        margin-bottom: 23px;
      }

      .outer_six_left_2 {
        font-weight: 700;
        font-size: 28px;
        color: #FFFFFF;
        letter-spacing: 3px;
      }

      .outer_six_left_3 {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 16px;
        position: relative;
        mask-image: linear-gradient(90deg, transparent 0%, #000 12%, #000 100%);
        -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 12%, #000 100%);

        .outer_six_left_3_row {
          overflow: hidden;
          width: 100%;

          &:nth-child(2) {
            margin-left: -70px;
            width: calc(100% + 70px);
          }
        }

        .outer_six_left_3_track {
          display: flex;
          width: max-content;
          will-change: transform;

          .outer_six_left_3_item {
            width: 100px;
            height: 44px;
            flex-shrink: 0;
            margin-right: 16px;
            /* background: linear-gradient(0deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%);
            border-radius: 12px;
            border: 2px solid #FFFFFF; */
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            /* padding: 6px 12px; */
            box-sizing: border-box;

            .outer_six_left_3_item_img {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
              border-radius: 12px;
            }
          }
        }

        .outer_six_left_3_track_l {
          animation: brandScrollLeft 15s linear infinite;
        }

        .outer_six_left_3_track_r {
          animation: brandScrollRight 15s linear infinite;
        }

        &:hover {

          .outer_six_left_3_track_l,
          .outer_six_left_3_track_r {
            animation-play-state: paused;
          }
        }
      }
    }

    .outer_six_right {
      width: 25.7%;
      background: #0057FE;
      border-radius: 40px;
      padding: 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      opacity: 0;
      overflow: hidden;

      .outer_six_right_1 {
        font-weight: 700;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 2px;
        margin-bottom: 23px;
      }

      .outer_six_right_2 {
        font-weight: 700;
        font-size: 28px;
        color: #FFFFFF;
        letter-spacing: 3px;
      }

      .outer_six_right_img {
        width: 133px;
        height: 82px;
        object-fit: contain;
        flex-shrink: 0;
      }
    }
  }

  .commonFoot {
    opacity: 1;
  }

  @keyframes brandScrollLeft {
    0% {
      transform: translate3d(0, 0, 0);
    }

    100% {
      transform: translate3d(-50%, 0, 0);
    }
  }

  @keyframes brandScrollRight {
    0% {
      transform: translate3d(-50%, 0, 0);
    }

    100% {
      transform: translate3d(0, 0, 0);
    }
  }
</style>
